import React from 'react'
import { IconMaps } from '@ow/icons'

export const workspaceConfig = [
  {
    key: 'app-list',
    title: '应用列表',
    icon: <IconMaps type="apps" width={24} height={24} fill="#FFC539" />,
  },
  {
    key: 'point-lib',
    title: '点位库',
    icon: <IconMaps type="point" width={24} height={24} fill="#DA7B12" />,
  },
  {
    key: 'index-lib',
    title: '指标库',
    icon: <IconMaps type="indexLib" width={24} height={24} fill="#91C61B" />,
  },
  {
    key: 'address-lisk',
    title: '通讯录',
    icon: <IconMaps type="category" width={24} height={24} fill="#0056FE" />,
  },
]

export const otherConfig = [
  {
    key: 'help-center',
    title: '帮助中心',
    icon: (
      <div style={{ transform: 'translateY(-4px)' }}>
        <IconMaps type="help" width={22} height={26} fill="#DA7B12" />
      </div>
    ),
  },
]
